export default {
      id: "8-0-usage",
      viewBox: "0 0 88 88",
      url: "assets/" + "sprite.svg#8-0-usage",
      toString: function () {
        return this.url;
      }
    }